import { Box, Button, Stack, Typography } from "@mui/material"
import { formatarBRL } from "@/lib/formato"
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import CheckIcon from '@mui/icons-material/Check'

interface StepFooterProps {
    total: number
    editando: boolean
    concluido: boolean
    podeVoltar: boolean
    proximoLabel: string
    proximoHabilitado: boolean
    confirmarHabilitado: boolean
    onVoltar: () => void
    onAvancar: () => void
    onConfirmar: () => void
}

function StepFooter({
    total,
    editando,
    concluido,
    podeVoltar,
    proximoLabel,
    proximoHabilitado,
    confirmarHabilitado,
    onVoltar,
    onAvancar,
    onConfirmar,
}: StepFooterProps): JSX.Element {
    return (
        <Stack
            spacing={1.5}
            sx={{
                p: 2,
                flexShrink: 0,
                borderTop: '1px solid',
                borderColor: 'divider',
                backgroundColor: 'background.paper',
            }}
        >
            <Stack direction="row" alignItems="baseline" justifyContent="space-between">
                <Typography variant="h6" color="text.secondary" sx={{ fontWeight: 600 }}>
                    Total do item
                </Typography>

                <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
                    {formatarBRL(total)}
                </Typography>
            </Stack>

            <Stack direction="row" spacing={2}>
                <Button
                    size="large"
                    variant="outlined"
                    onClick={onVoltar}
                    disabled={!podeVoltar}
                    startIcon={<ArrowBackIcon />}
                    sx={{ flex: 1, py: 1.5, borderRadius: 3, textTransform: 'none' }}
                >
                    Voltar
                </Button>

                {concluido ? (
                    <Button
                        size="large"
                        variant="contained"
                        onClick={onConfirmar}
                        disabled={!confirmarHabilitado}
                        startIcon={<CheckIcon />}
                        sx={{ flex: 1, py: 1.5, borderRadius: 3, textTransform: 'none' }}
                    >
                        {editando ? 'Salvar alterações' : 'Adicionar ao carrinho'}
                    </Button>
                ) : (
                    <Box sx={{ flex: 1, display: 'flex' }}>
                        <Button
                            size="large"
                            variant="contained"
                            onClick={onAvancar}
                            disabled={!proximoHabilitado}
                            endIcon={<ArrowForwardIcon />}
                            sx={{ flex: 1, py: 1.5, borderRadius: 3, textTransform: 'none' }}
                        >
                            {proximoLabel}
                        </Button>
                    </Box>
                )}
            </Stack>
        </Stack>
    )
}

export default StepFooter